import styled from "styled-components";

export const StyledButton = styled.button`
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  text-transform: capitalize;
  -webkit-letter-spacing: normal;
  -moz-letter-spacing: normal;
  -ms-letter-spacing: normal;
  border: none;
  background: none;
  cursor: pointer;
  outline: none;
  text-decoration: none;
  transition: 0.3s;
  ${({ headerBackground }) =>
    headerBackground &&
    `
      
  color: ${headerBackground ? "#264445" : "#ffffff"};
  
  `};
  :hover {
    color: #89C35C;
  }

  ${({ darkColor }) =>
    darkColor &&
    `
      
  color: #37373A
  
  `}
`;
